import HeffronApps from '@/app/constants/account/HeffronApps.json';

const heffronSubscriptionAppsArr = HeffronApps
  .filter(app => app.appType === 'SUBSCRIPTION')
  .map(app => ({
    key: app.product,
    value: app.appName,
  }));

export const SUBSCRIPTION_APPS = heffronSubscriptionAppsArr.reduce((prev, curr) => {
  prev[curr.key] = curr.value;
  return prev;
}, {});

export const apps = [
  {
    appName: 'HOME',
    display: 'Home',
    url: '/',
    index: 0,
    isExternal: false,
  },
  {
    appName: 'ACCOUNT_MANAGEMENT',
    display: 'Account Management',
    url: '/account',
    index: 1,
    isExternal: false,
  },
  {
    appName: 'TOOLKIT',
    display: 'Super Toolkit',
    url: '/toolkit/investment-strategy/dashboard',
    index: 2,
    isExternal: false,
  },
  {
    appName: 'COMPANION',
    display: 'Super Companion',
    url: 'https://companion.heffron.com.au',
    index: 3,
    isExternal: true,
  },
  {
    appName: 'BITES',
    display: 'Education Bites',
    url: process.env.VUE_APP_ABSORB_URL,
    index: 4,
    isExternal: true,
  },
];

export const activeAppStatus = [
  'ACTIVE',
  'INACTIVE',
  'PENDING',
];


export default {
  SUBSCRIPTION_APPS,
  apps,
  activeAppStatus,
};
